var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1OpenMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 35V20.23L45.87 9H19v26h-9v32h56V35H56zM23 13h21v9h8v20.28L38 51.6l-15-10V13zm-9 27l13.09 9.15L14 61V40zm2.28 23l13.38-12.13L38 56.4l8.61-5.69L60.18 63h-43.9zM62 61L49.17 49h.06L62 40v21zM48 35H27v-3h21v3zm-5 6H27v-3h16v3zm-4-12H27v-3h12v3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Open_mail.79b63890.svg";
export { SvgH1OpenMail as ReactComponent };